import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

function OptionalTooltip({
  isVisible,
  children,
  ...props
}: { isVisible: boolean } & TooltipProps): JSX.Element {
  return isVisible ? <Tooltip {...props}>{children}</Tooltip> : children;
}

export { OptionalTooltip };
